import React from "react";

const SpecimenSearchDesktop = React.lazy(() => import("./ui/SpecimenSearch"));

export const SpecimenSearchPage = () => {
  return <SpecimenSearchDesktop />;
};
